var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#6468c8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 17,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130 -739)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(130 739)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -739)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(130 739)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130 -731)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(130 739)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -731)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(130 739)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130 -723)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(130 739)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -723)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(130 739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridDots);
export default __webpack_public_path__ + "static/media/grid-dots.fc1cfce4e427d4ff9592cf2ed898ed02.svg";
export { ForwardRef as ReactComponent };